$(document).ready(function(){

  $(".level_1>li>details-disclosure>details").mouseenter(function(){
    let details = $(this);

    if(typeof details.attr('open') == 'undefined' ){
      $(this).parents('.level_1').find('details').removeAttr('open');
      details.find('details').first().attr('open',true);
      details.attr('open',true);
    }
  }).mouseleave(function() {
    $(this).parents('.level_1').find('details').removeAttr('open');
  });
  
  $(".level_2_submenu details").hover(function(){
    $(this).parents('.level_2_submenu').find('details').removeAttr('open');
    $(this).attr('open',true);
  });


  $(document).on('click','.collection-grid a.pagination__item',function(e){
    e.preventDefault();
    let sectionId = $(this).parents('.shopify-section').attr('id').replace('shopify-section-','');
    let href = $(this).attr('href');
    let next_page = window.location.origin+href+'&section_id='+sectionId;
    
    $(window).scrollTop(0);
    $('.collection-grid .collection').addClass('loading');
    
    $.ajax({
      url: next_page,
      type: 'get',
      success: function(html){
        let grid = $(html).find('.collection-grid').html();
        $('.collection-grid').html(grid);
        $('.collection-grid .collection').removeClass('loading');
        window.history.pushState('', '', href);
      }
    });
  });

  $("[data-end-of-day]").each(function(){

    let element = $(this);

    if(element.attr("data-end-of-day")!=""){

      let x = setInterval(function() {
        
        let temp = new Date();
        let start_time = element.attr('data-end-of-day');

        temp = (temp.getUTCMonth()+1)+'/'+temp.getUTCDate()+'/'+temp.getUTCFullYear()+' '+temp.getUTCHours()+':'+temp.getUTCMinutes()+':'+temp.getUTCSeconds();
        
        let now = new Date(temp).getTime();
        let countDownDate = new Date(start_time).getTime();
        let distance = countDownDate - now;
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        html = "<div class='countdown_day'>"+days + "<span>Days</span></div><div class='countdown_hour'> " + hours + "<span>hrs</span></div><div class='countdown_min'>"
        + minutes + "<span>min</span></div><div class='countdown_sec'>" + seconds+"<span>sec</span></div>";
        
        element.find(".product_countdown").html(html)
        if (distance < 0) {
          clearInterval(x);
          element.find(".content_count_down").hide();
          //window.location.reload();
        }else{
          element.find(".content_count_down").show();
        }
      }, 1000);
    }

  });
  
  $(document).on('click','.guest_user_wishlist',function(){
    url = window.location.href;
    id = $(this).attr('data-product-id');

    localStorage.setItem("wishlist_redirect", url);
    localStorage.setItem("wishlist_id", id);
    window.location.href = "/account/login?return_url="+url;

  });

});

$(window).on("load", function (e) {
  
  $('.wishlist_icon i').click(function(){
    
    let ele = $(this).parents('.wishlist_icon');
    let flag = ele.find('i').hasClass('ssw-icon-heart');
    ele.find('.ssw-faveiticon').hide();
    ele.find('.loading-overlay__spinner').removeClass('hidden');

    let timer = setInterval(function(){

      let check = ele.find('i').hasClass('ssw-icon-heart');
      console.log(flag,check)
      if(flag!=check){
        ele.find('.ssw-faveiticon').show();
        ele.find('.loading-overlay__spinner').addClass('hidden');
        clearTimeout(timer)
      }

    },1000);

  });
    
});